var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.7899 0.624791C0.827158 0.165808 -0.231189 1.04584 0.0444367 2.07616L2.05964 9.60921C2.16316 9.99621 2.48766 10.2841 2.88425 10.3407L12.7676 11.7526C13.0538 11.7935 13.0538 12.2067 12.7676 12.2476L2.88529 13.6594C2.4887 13.716 2.16421 14.0039 2.06068 14.3909L0.0444365 21.9278C-0.231191 22.9582 0.827162 23.8382 1.7899 23.3792L23.2875 13.1303C24.2369 12.6777 24.2369 11.3263 23.2875 10.8737L1.7899 0.624791Z",
    fill: "#6ac9ce"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2280_119090",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.0234 21.2469) rotate(-142.006) scale(33.4402 32.3913)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.336272,
    stopColor: "#0F6CBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2D87C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DDDD8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/Send.c3faa367406b8890bce0fc20e87658f2.svg";
export { ForwardRef as ReactComponent };